import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueBootstrap from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import firebaseSrv from './services/firebaseSrv.js'
import BaseIcon from '@/components/BaseIcon.vue'
import 'nprogress/nprogress.css'
import VueTextareaAutosize from 'vue-textarea-autosize'
import VuePhotoSwipe from './plugins/photoswipe'
import JsonExcel from 'vue-json-excel'
import VueLazyload from 'vue-lazyload'
import VueCookie from 'vue-cookie'

Vue.use(VueBootstrap)
Vue.use(VueTextareaAutosize)
Vue.use(VuePhotoSwipe)
Vue.use(VueLazyload)
Vue.use(VueCookie)

Vue.component('BaseIcon', BaseIcon)
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
